export const UPDATE_MODULES = "UPDATE_MODULES";
export const UPDATE_TOPICS = "UPDATE_TOPICS";
export const UPDATE_PARTS = "UPDATE_PARTS";
export const UPDATE_KEY_TERMS = "UPDATE_KEY_TERMS";
export const UPDATE_ACTIVITIES = "UPDATE_ACTIVITIES";
export const UPDATE_PAGES = "UPDATE_PAGES";

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const TOGGLE_LINKS_SIDEBAR = "TOGGLE_LINKS_SIDEBAR";

export const SET_KEYTERM = "SET_KEYTERM";
export const CLEAR_KEYTERM = "CLEAR_KEYTERM";

export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_PROGRESS = "UPDATE_PROGRESS";
export const CLEAR_PROGRESS = "CLEAR_PROGRESS";
export const UPDATE_FINISHED_TOPICS = "UPDATE_FINISHED_TOPICS";
export const UPDATE_FINISHED_SUB_SECTION = "UPDATE_FINISHED_SUB_SECTION";
export const UPDATE_CURRENT_TOPIC = "UPDATE_CURRENT_TOPIC";

export const HIDE_SIDEBAR = "HIDE_SIDEBAR";
export const HIDE_LINKBAR = "HIDE_LINKBAR";

export const TOGGLE_SHARE_MODAL = "TOGGLE_SHARE_MODAL";
export const TOGGLE_BADGE_MODAL = "TOGGLE_BADGE_MODAL";
export const TOGGLE_SHARE_BADGE_MODAL = "TOGGLE_SHARE_BADGE_MODAL";
export const TOGGLE_SWEEPSTAKES_BADGE_MODAL = "TOGGLE_SWEEPSTAKES_BADGE_MODAL";
export const SHOW_SWEEPSTAKES_BADGE_MODAL = "SHOW_SWEEPSTAKES_BADGE_MODAL";
export const TOGGLE_UPDATE_SIDEBAR = "TOGGLE_UPDATE_SIDEBAR";
export const SET_SECTION = "SET_SECTION";

export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const UPDATE_CURRENT_LANGUAGE = "UPDATE_CURRENT_LANGUAGE";

export const UPDATE_SHARES_COUNT = "UPDATE_SHARES_COUNT";
export const UPDATE_SHARES_ID = "UPDATE_SHARES_ID";

export const UPDATE_AFFILIATE = "UPDATE_AFFILIATE";
export const UPDATE_CONFIG = "UPDATE_CONFIG";

export const UPDATE_ADOBE_SETTINGS = "UPDATE_ADOBE_SETTINGS";
